import type { OrganizationRef, Person, Team } from '../NinetyImports/types'
export type { OrganizationRef, Person, Team }
export interface Mapping {
  team_id: string | number
  anchor_year: string | number
  plan_quarter: string
  owners: Record<string, string | number>
  row_teams: Record<string, string | number>
  accepted_approximations: string[]
  excluded_rows: string[]
  excluded_groups: string[]
  confirm_calendar: boolean
  confirm_matching: boolean
}
export interface Row {
  resolved_team_id?: number
  resolved_entries?: Array<{ date: string; source_date?: string; period?: string; value: string }>
  key: string
  kind: string
  name: string
  owner?: string
  group?: string
  file?: string
  sheet?: string
  row?: number
  disposition?: string
  data?: Record<string, unknown>
  errors?: unknown[]
  warnings?: unknown[]
  [key: string]: unknown
}
export interface Preview {
  alignment_warnings?: string[]
  rows: Row[]
  valid: boolean
  counts: Record<string, unknown>
  errors: unknown[]
  warnings: unknown[]
}
export interface Batch {
  id: number
  status: string
  created_at: string
  expires_at?: string
  mapping?: Partial<Mapping>
  result?: Record<string, unknown> | null
  payload?: { rows?: Row[]; files?: unknown[]; diagnostics?: unknown[] }
}
export const label = (key: string) => key.replace(/_/g, ' ')
export const text = (value: unknown): string => value == null ? '—' : typeof value === 'object' ? JSON.stringify(value) : String(value)